import { render, staticRenderFns } from "./InputAttachment.vue?vue&type=template&id=a9a391b4"
import script from "./InputAttachment.vue?vue&type=script&lang=js"
export * from "./InputAttachment.vue?vue&type=script&lang=js"
import style0 from "./InputAttachment.vue?vue&type=style&index=0&id=a9a391b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports